/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LogoutRequest interface.
 */
export function instanceOfLogoutRequest(value) {
    return true;
}
export function LogoutRequestFromJSON(json) {
    return LogoutRequestFromJSONTyped(json, false);
}
export function LogoutRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accountId': json['account_id'] == null ? undefined : json['account_id'],
        'all': json['all'] == null ? undefined : json['all'],
    };
}
export function LogoutRequestToJSON(json) {
    return LogoutRequestToJSONTyped(json, false);
}
export function LogoutRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'account_id': value['accountId'],
        'all': value['all'],
    };
}
